import axios, {AxiosResponse} from 'axios';
import {ForbiddenError, NotSupportedError} from "~/types/error-type.ts";

axios.interceptors.response.use(
    (response: AxiosResponse) => response,
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    async (error: any): Promise<any> => {
        /* eslint-disable-next-line */
        console.dir(error);

        if (error.status === 403) {
            throw new ForbiddenError();
        }
        if (error.status === 501) {
            throw new NotSupportedError();
        }
        return Promise.reject(error);
    }
);

axios.defaults.withCredentials = false;
